import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { platformLabel, useEnv } from '../../../context/env-context';
import { withPageProviders } from '../../../context/page-context';

export const HomePageRedirectPage = withPageProviders(HomePageRedirectContent);

function HomePageRedirectContent() {
  const platform = platformLabel(useEnv().connected_platform);

  return (
    <RedirectPage
      title={t('features:home.pages.redirect.title', { platform })}
      subtitle={t('features:home.pages.redirect.description', { platform })}
      action={t('features:home.pages.redirect.action', { platform })}
      imageType="orders"
    />
  );
}
